import React, { useState } from 'react';
import './RulesFormFooterSection.css';

const RulesFormFooterSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    experience: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbztErrCb3Ig1TMsn6dax9S92lDDAlThILFHN8BBM89l7a6ZCXx6luKR4PUe-KH7WKNd/exec';

    try {
      const data = new URLSearchParams();

      data.append('Name', formData.name);
      data.append('Email', formData.email);
      data.append('Phone', formData.phone);
      data.append('Experience', formData.experience);

      const now = new Date();
      data.append('Timestamp', now.toISOString());

      const response = await fetch(GOOGLE_SCRIPT_URL, {
        method: 'POST',
        body: data
      });

      console.log("Response:", response);

      setSubmitStatus('success');

      // Reset form
      setFormData({
        name: '',
        email: '',
        phone: '',
        experience: ''
      });

    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const scrollToSection = (e, id) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };
  return (
    <section className="mc-section">
      <div className="mc-rff-container">

        {/* Rules & Regulations */}
        <div className="mc-rules">
          <h2 className="mc-rules-title mc-gradient-accent">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mc-gradient-text" style={{ color: 'var(--mc-primary)', marginRight: '1rem' }}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
            Rules & Regulations
          </h2>
          <ul className="mc-rules-list">
            <li className="mc-rule-item">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mc-rule-icon"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
              <p className="mc-rule-text">100% Attendance is compulsory for AI Tools Bootcamp.</p>
            </li>
            
            <li className="mc-rule-item">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mc-rule-icon"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
              <p className="mc-rule-text">Admission can not be transferred or cancelled under any circumstances.</p>
            </li>
            <li className="mc-rule-item">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mc-rule-icon"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
              <p className="mc-rule-text">Fees non-refundable.</p>
            </li>
          </ul>
        </div>

        {/* Contact/Enrollment Form */}
        <div className="mc-form-section" id="contact-form">
          <div className="mc-form-header">
            <h2 className="mc-form-title mc-gradient-accent">Secure Your Spot</h2>
            <p style={{ color: 'var(--mc-text-muted)' }}>Drop your details below and our enrollment team will reach out immediately.</p>
          </div>

          <div className="mc-glass-card mc-rules-card" style={{ padding: '3rem' }}>
            {submitStatus === 'success' ? (
              <div className="mc-form-success" style={{ textAlign: 'center', padding: '2rem 0' }}>
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginBottom: '1rem' }}><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
                <h3 style={{ color: '#22c55e', marginBottom: '0.5rem', fontSize: '1.5rem' }}>Successfully Enrolled!</h3>
                <p style={{ color: 'var(--mc-text-muted)' }}>We've received your details. Our team will contact you shortly.</p>
              </div>
            ) : (
              <form className="mc-form" onSubmit={handleSubmit}>
                {submitStatus === 'error' && (
                  <div style={{ color: '#ef4444', backgroundColor: 'rgba(239, 68, 68, 0.1)', padding: '0.75rem', borderRadius: '0.5rem', marginBottom: '1rem', border: '1px solid rgba(239, 68, 68, 0.3)' }}>
                    Something went wrong. Please try again.
                  </div>
                )}

                <div className="mc-form-group">
                  <label className="mc-form-label">Full Name</label>
                  <input type="text" name="name" value={formData.name} onChange={handleChange} className="mc-form-input" placeholder="Enter your full name" required disabled={isSubmitting} />
                </div>

                <div className="mc-form-group">
                  <label className="mc-form-label">Email Address</label>
                  <input type="email" name="email" value={formData.email} onChange={handleChange} className="mc-form-input" placeholder="alex@example.com" required disabled={isSubmitting} />
                </div>

                <div className="mc-form-group">
                  <label className="mc-form-label">Phone Number</label>
                  <input type="tel" name="phone" value={formData.phone} onChange={handleChange} className="mc-form-input" placeholder="+91 XXXXX XXXXX" required disabled={isSubmitting} />
                </div>

                <div className="mc-form-group">
                  <label className="mc-form-label">Experience Level</label>
                  <select name="experience" value={formData.experience} onChange={handleChange} className="mc-form-select" required disabled={isSubmitting}>
                    <option value="">Select your level</option>
                    <option value="beginner">Beginner (No Idea)</option>
                    <option value="intermediate">Intermediate (Used ChatGPT)</option>
                    <option value="advanced">Advanced (Built AI Projects)</option>
                  </select>
                </div>

                <button type="submit" className="mc-form-btn" disabled={isSubmitting} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '0.5rem' }}>
                  {isSubmitting ? (
                    <>
                      <div className="mc-loader-spinner" style={{ width: '20px', height: '20px', border: '3px solid rgba(255,255,255,0.3)', borderTopColor: '#fff', borderRadius: '50%', animation: 'spin 1s linear infinite' }}></div>
                      Submitting...
                    </>
                  ) : (
                    'Enroll Now — Limited Seats →'
                  )}
                </button>
              </form>
            )}
          </div>
        </div>
{/*
        // Footer 
        <footer className="mc-footer">
          <div className="mc-footer-grid">
            <div>
              <div className="mc-footer-brand mc-gradient-text">AI Tools Bootcamp</div>
              <p className="mc-footer-desc">
                The premier accelerator for creative professionals looking to weaponize AI in their career.
              </p>
            </div>

            <div>
              <h4 className="mc-footer-col-title">Navigation</h4>
              <div className="mc-footer-links">
                <a href="#curriculum" onClick={(e) => scrollToSection(e, 'curriculum')} className="mc-footer-link">Curriculum</a>
                <a href="#ceo" onClick={(e) => scrollToSection(e, 'ceo')} className="mc-footer-link">Mentor</a>
                <a href="#fees" onClick={(e) => scrollToSection(e, 'fees')} className="mc-footer-link">Pricing</a>
                <a href="#certificates" onClick={(e) => scrollToSection(e, 'certificates')} className="mc-footer-link">Certification</a>
              </div>
            </div>

            <div>
              <h4 className="mc-footer-col-title">Legal</h4>
              <div className="mc-footer-links">
                <span className="mc-footer-link" style={{ cursor: 'default' }}>Privacy Policy</span>
                <span className="mc-footer-link" style={{ cursor: 'default' }}>Terms of Service</span>
                <span className="mc-footer-link" style={{ cursor: 'default' }}>Refund Policy</span>
              </div>
            </div>

            <div>
              <h4 className="mc-footer-col-title">Social</h4>
              <div className="mc-footer-links">
                <span className="mc-footer-link" style={{ cursor: 'default' }}>Twitter</span>
                <span className="mc-footer-link" style={{ cursor: 'default' }}>LinkedIn</span>
                <span className="mc-footer-link" style={{ cursor: 'default' }}>YouTube</span>
                <span className="mc-footer-link" style={{ cursor: 'default' }}>Discord</span>
              </div>
            </div>
          </div>

          <div className="mc-footer-bottom">
            © 2026 AI Tools Bootcamp. Core2web, Pune. All rights reserved.
          </div>
        </footer>
        */}

      </div>
    </section>
  );
};

export default RulesFormFooterSection;
